var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.results
    ? _c(
        "div",
        [
          _c("transition", { attrs: { name: "slide" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.result.id,
                    expression: "result.id",
                  },
                ],
                ref: "toast",
                staticClass:
                  "g-cart-toast g-layout g-layout--no-wrap g-layout--align-center",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "g-cart-toast__image-wrap g-layout__item no-grow no-padding",
                  },
                  [
                    _c("img", {
                      directives: [
                        {
                          name: "lazy",
                          rawName: "v-lazy",
                          value: {
                            src: _vm.result.thumbnailImageUrl,
                            error: _vm.errorImage,
                            loading: _vm.loadingImage,
                          },
                          expression:
                            "{ src: result.thumbnailImageUrl, error: errorImage, loading: loadingImage }",
                        },
                      ],
                      attrs: { alt: "Image for " + _vm.result.name },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "g-layout__item" }, [
                  _vm.success == true
                    ? _c(
                        "div",
                        { staticClass: "g-cart-toast-message is-success" },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t+" +
                              _vm._s(_vm.quantity) +
                              " Successfully Added to Cart!\n\t\t\t\t"
                          ),
                        ]
                      )
                    : _c("div", {
                        staticClass: "g-cart-toast-message is-warning",
                        domProps: { innerHTML: _vm._s(_vm.message) },
                      }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "g-cart-toast-name",
                    domProps: { innerHTML: _vm._s(_vm.result.name) },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "g-layout__item no-grow" }, [
                  _c(
                    "a",
                    {
                      staticClass: "g-cart-toast-cta g-button g-button--hollow",
                      attrs: { href: _vm.basketUrl },
                    },
                    [
                      _c("span", [_vm._v("View Cart")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "u-hidden u-inline--l" }, [
                        _vm._v("& Checkout"),
                      ]),
                    ]
                  ),
                ]),
              ]
            ),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }